import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React from 'react';
import type {ImageType} from '../../../types/Image';
import {Image} from '../../atoms/Image/Image';
import {UnstyledLinkLinaria} from '../../atoms/UnstyledLink/UnstyledLinkLinaria';
import {HorizontalList} from '../../molecules/HorizontalList/HorizontalList';

interface SocialLinksProps {
  entries: {
    image?: ImageType;
    href: string;
  }[];
}

export const SocialLinks: React.FC<SocialLinksProps> = ({entries}) => {
  const {t} = useTranslation();

  return (
    <SocialLinksWrapper data-testid="socialLinks">
      {entries.map((item, index) =>
        item.image ? (
          <SocialLinkItem
            to={item.href}
            key={index}
            aria-label={t('Social link')}
          >
            <StyledImage
              src={item.image.url}
              alt={item.image.description}
              breakpoints={[]}
              ratio={'1:1'}
              widths={[75]}
              loading="lazy"
              importance="low"
            />
          </SocialLinkItem>
        ) : null,
      )}
    </SocialLinksWrapper>
  );
};

const SocialLinksWrapper = styled(HorizontalList)`
  padding: 0;
`;

const SocialLinkItem = styled(UnstyledLinkLinaria)`
  display: flex;
  margin: 1rem 0.5rem;
`;

const StyledImage = styled(Image)`
  height: 24px;
  min-width: 24px;
  object-fit: contain;
`;
